module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_vm._v("Loading...")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a2b3761"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 16
// module chunks = 0